import React from 'react';
import ClassNames from 'classnames';
import DateTime from 'utils/date-time';
import moment from 'moment-timezone';
import Transition from 'components/transition-groups/Transition';

export default React.createClass({

	propTypes: {
		selectedDate: React.PropTypes.object.isRequired,
		toggleTimeDisplay: React.PropTypes.func.isRequired,
		onNowButtonClick: React.PropTypes.func.isRequired,
		timePicker: React.PropTypes.bool,
		nowButtonActive: React.PropTypes.bool
	},

	getInitialState() {
		return {
			transitionDirection: 'up',
			nowButtonActive: this.props.nowButtonActive
		};
	},

	componentWillReceiveProps(nextProps) {
		let direction;

		if (nextProps.selectedDate !== this.props.selectedDate) {
			direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
			this.setState({
				transitionDirection: direction
			});
		};
	},

	render() {

		let { selectedDate, timePicker } = this.props,
			classes = ClassNames(this.props.className , 'lui-date-picker-date-display'),
			dayOfWeek = moment(selectedDate).format('dddd'),
			month = moment(selectedDate).format('MMM'),
			day = moment(selectedDate).date(),
			year = moment(selectedDate).year(),
			nowButtonClasses = ClassNames('lui-date-picker-date-display-now-button' , {
				'lui-is-active' : this.props.nowButtonActive
			}),
			timeDisplayIcon;

			if (timePicker) {
				timeDisplayIcon = (
				<i 
					className="lui-date-picker-date-display-time-icon fa fa-clock-o"
					onClick={this._handleClockIconClick} />
				);
			};

		return (
		  <div {...this.props} className={classes}>

			<Transition
				className="lui-date-picker-date-display-dow"
				direction={this.state.transitionDirection}>

				<div key={dayOfWeek}>{dayOfWeek}</div>
			
			</Transition>

			<div className="lui-date-picker-date-display-date">

			<Transition
				className="lui-date-picker-date-display-month"
				direction={this.state.transitionDirection}>
				<div key={month}>{month}</div>
			</Transition>

			<Transition
				className="lui-date-picker-date-display-day"
				direction={this.state.transitionDirection}>
				<div key={day}>{day}</div>
			</Transition>

			<Transition
				className="lui-date-picker-date-display-year"
				direction={this.state.transitionDirection}>
				<div key={year}>{year}</div>
			</Transition>
			
			{timeDisplayIcon}

			<div className={nowButtonClasses} onClick={this.props.onNowButtonClick}> Now </div>

			</div>

		  </div>
		);
	},

	_handleClockIconClick() {
		this.props.toggleTimeDisplay();
	},
});


/** WEBPACK FOOTER **
 ** ./src/components/date-picker/DateDisplay.js
 **/